$chatBox = $('#chatBox');

$chatBox.scrollTop($chatBox.prop("scrollHeight"));